<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <base-header
      :title="$t('app.conversion-divisas.name')"
      link="Dashboard"
    />
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-material-card color="primary">
          <template v-slot:heading>
            <v-row>
              <v-col class="flex-grow-1 flex-grow-0">
                <div class="display-2 font-weight-light">
                  {{ $t('app.conversion-divisas.title') }}
                </div>

                <div class="subtitle-1 font-weight-light">
                  {{ $t('app.conversion-divisas.subtitle') }}
                </div>
              </v-col>
              <v-col class="d-flex align-center flex-grow-0 flex-shrink-0">
                <v-btn
                  dark
                  @click="openItemAdd"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-plus-circle
                  </v-icon>

                  {{ $t('app.buttons.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <v-card-title>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="filters.selected.query"
                  :label="$t('app.buttons.search')"
                  rounded
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :search="filters.selected.query"
          >
            <template v-slot:item.actions="{ item }">
              <v-col class="d-flex justify-end">
                <v-btn
                  icon
                  @click="openItemDetail(item)"
                >
                  <v-icon>
                    mdi-eye
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemEdit(item)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemDelete(item)"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <conversion-divisas-add />
    <conversion-divisas-edit />
    <conversion-divisas-detail />
    <conversion-divisas-delete />
  </v-container>
</template>

<script>
  export default {
    name: 'ConversionDivisas',
    components: {
      ConversionDivisasAdd: () => import('./ConversionDivisasAdd'),
      ConversionDivisasEdit: () => import('./ConversionDivisasEdit'),
      ConversionDivisasDetail: () => import('./ConversionDivisasDetail'),
      ConversionDivisasDelete: () => import('./ConversionDivisasDelete'),
    },
    data () {
      return {
        headers: [
          {
            text: this.$t('app.headers.id'),
            value: 'id',
          },
          {
            text: this.$t('app.conversion-divisas.from_currency'),
            value: 'fromCurrency.name',
          },
          {
            text: this.$t('app.conversion-divisas.to_currency'),
            value: 'toCurrency.name',
          },
          {
            text: this.$t('app.conversion-divisas.factor'),
            value: 'factor',
          },
          {
            text: '',
            value: 'actions',
            sortable: false,
          },
        ],
        items: [],
        filters: {
          data: {
            items: [],
          },
          selected: {
            items: [],
            query: '',
          },
        },
      }
    },
    mounted () {
      this.init()

      EventBus.$on('reload-items', () => {
        this.init()
      })
    },
    methods: {
      async init () {
        this.toggleLoader()

        this.items = await this.getConversionDivisas()

        this.toggleLoader()
      },
      openItemAdd () {
        EventBus.$emit('conversion-divisas-add')
      },
      openItemEdit (item) {
        EventBus.$emit('conversion-divisas-edit', item)
      },
      openItemDetail (item) {
        EventBus.$emit('conversion-divisas-detail', item)
      },
      openItemDelete (item) {
        EventBus.$emit('conversion-divisas-delete', item)
      },
    },
  }
</script>

<style scoped>

</style>
